import { render, staticRenderFns } from "./wtLightboxAsset.component.vue?vue&type=template&id=6f2c3212&scoped=true&"
import script from "./wtLightboxAsset.component.vue?vue&type=script&lang=js&"
export * from "./wtLightboxAsset.component.vue?vue&type=script&lang=js&"
import style0 from "./wtLightboxAsset.component.vue?vue&type=style&index=0&id=6f2c3212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c3212",
  null
  
)

export default component.exports